export default "__VITE_ASSET__Cwm9yBLr__"